var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("topbar", { attrs: { text: "活动详情" } }),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.activeDetail.activeTheme))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "time" }, [
        _vm._v("发布时间：" + _vm._s(_vm.activeDetail.activeTime))
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "content",
        domProps: { innerHTML: _vm._s(_vm.activeDetail.content) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e343b60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e343b60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/activityDetail.vue
// module id = null
// module chunks = 